/**
 * ============================================
 * CUSTOM.JS - FIXED VERSION
 * ============================================
 */

document.addEventListener('DOMContentLoaded', function() {
  'use strict';

  // ========================================
  // CHECK GSAP
  // ========================================

  const hasGSAP = typeof gsap !== 'undefined';

  if (!hasGSAP) {
    console.warn('GSAP not loaded. Add GSAP CDN to theme.liquid');
  }

  // ========================================
  // HERO SLIDER
  // ========================================

  const slides = document.querySelectorAll('.hero-slide');
  const dots = document.querySelectorAll('.slider-dot');
  const prevBtn = document.querySelector('.slider-prev');
  const nextBtn = document.querySelector('.slider-next');

  if (slides.length > 0) {
    let currentSlide = 0;
    let slideInterval;
    const autoSlideDelay = 6000;

    function goToSlide(index) {
      slides.forEach(slide => slide.classList.remove('active'));
      dots.forEach(dot => dot.classList.remove('active'));
      slides[index].classList.add('active');
      dots[index].classList.add('active');
      currentSlide = index;
    }

    function nextSlide() {
      goToSlide((currentSlide + 1) % slides.length);
    }

    function prevSlide() {
      goToSlide((currentSlide - 1 + slides.length) % slides.length);
    }

    function startAutoSlide() {
      slideInterval = setInterval(nextSlide, autoSlideDelay);
    }

    function stopAutoSlide() {
      clearInterval(slideInterval);
    }

    function restartAutoSlide() {
      stopAutoSlide();
      startAutoSlide();
    }

    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => { goToSlide(index); restartAutoSlide(); });
    });

    if (prevBtn) prevBtn.addEventListener('click', () => { prevSlide(); restartAutoSlide(); });
    if (nextBtn) nextBtn.addEventListener('click', () => { nextSlide(); restartAutoSlide(); });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') { prevSlide(); restartAutoSlide(); }
      else if (e.key === 'ArrowRight') { nextSlide(); restartAutoSlide(); }
    });

    const heroSlider = document.querySelector('.hero-slider');
    if (heroSlider) {
      heroSlider.addEventListener('mouseenter', stopAutoSlide);
      heroSlider.addEventListener('mouseleave', startAutoSlide);
    }

    goToSlide(0);
    startAutoSlide();
  }

  // ========================================
  // CATEGORIES - SCROLL REVEAL
  // ========================================

  const categoryCards = document.querySelectorAll('.category-card');

  if (categoryCards.length > 0) {
    const categoryObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setTimeout(() => { entry.target.classList.add('reveal'); }, entry.target.dataset.index * 100);
          categoryObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });

    categoryCards.forEach(card => categoryObserver.observe(card));
  }

  // ========================================
  // BEST SELLER - SCROLL REVEAL
  // ========================================

  const bestsellerCards = document.querySelectorAll('.bestseller-card');

  if (bestsellerCards.length > 0) {
    const bestsellerObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setTimeout(() => { entry.target.classList.add('reveal'); }, entry.target.dataset.index * 120);
          bestsellerObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });

    bestsellerCards.forEach(card => bestsellerObserver.observe(card));
  }

  // ========================================
  // WHY US SECTION - REVEAL ANIMATIONS
  // ========================================

  const whyUsSection = document.querySelector('.why-us-section');

  if (whyUsSection && hasGSAP) {
    const whyUsContent = whyUsSection.querySelector('.why-us-content');
    const whyUsVideo = whyUsSection.querySelector('.why-us-video-wrapper');

    const whyUsObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          gsap.to(whyUsContent, { opacity: 1, y: 0, duration: 0.8, ease: 'power3.out' });
          gsap.to(whyUsVideo, { opacity: 1, y: 0, duration: 0.8, delay: 0.2, ease: 'power3.out' });
          whyUsObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2 });

    whyUsObserver.observe(whyUsSection);
  }

  // ========================================
  // VIDEO CARD - PARALLAX TILT (Desktop)
  // ========================================

  const videoCard = document.getElementById('videoCard');

  if (videoCard && window.innerWidth > 1024 && hasGSAP) {
    let tiltX = 0, tiltY = 0, currentX = 0, currentY = 0;

    videoCard.addEventListener('mousemove', (e) => {
      const rect = videoCard.getBoundingClientRect();
      tiltX = ((e.clientY - rect.top - rect.height / 2) / (rect.height / 2)) * 8;
      tiltY = ((e.clientX - rect.left - rect.width / 2) / (rect.width / 2)) * -8;
    });

    videoCard.addEventListener('mouseleave', () => { tiltX = 0; tiltY = 0; });

    function animateTilt() {
      currentX += (tiltX - currentX) * 0.1;
      currentY += (tiltY - currentY) * 0.1;
      gsap.set(videoCard, { rotationX: currentX, rotationY: currentY, transformPerspective: 1000 });
      requestAnimationFrame(animateTilt);
    }

    animateTilt();
  }

  // ========================================
  // VIDEO MODAL
  // ========================================

  const playButton = document.getElementById('playButton');
  const videoModal = document.getElementById('videoModal');
  const modalBackdrop = document.getElementById('modalBackdrop');
  const modalContainer = document.getElementById('modalContainer');
  const modalClose = document.getElementById('modalClose');
  const videoIframe = document.getElementById('videoIframe');

  function openVideoModal() {
    if (!videoModal) return;
    const videoId = videoModal.getAttribute('data-video-id') || 'dQw4w9WgXcQ';
    videoIframe.src = `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`;
    videoModal.style.display = 'flex';
    document.body.style.overflow = 'hidden';

    if (hasGSAP) {
      gsap.timeline()
        .to(videoModal, { opacity: 1, duration: 0.3 })
        .to(modalContainer, { scale: 1, duration: 0.6, ease: 'expo.out' }, '-=0.2');
    } else {
      videoModal.style.opacity = '1';
      modalContainer.style.transform = 'scale(1)';
    }
  }

  function closeVideoModal() {
    if (!videoModal) return;
    if (hasGSAP) {
      gsap.timeline()
        .to(modalContainer, { scale: 0.9, duration: 0.4, ease: 'power3.in' })
        .to(videoModal, { opacity: 0, duration: 0.3, onComplete: () => {
          videoModal.style.display = 'none';
          videoIframe.src = '';
          document.body.style.overflow = '';
        }}, '-=0.2');
    } else {
      videoModal.style.opacity = '0';
      setTimeout(() => {
        videoModal.style.display = 'none';
        videoIframe.src = '';
        document.body.style.overflow = '';
      }, 400);
    }
  }

  if (playButton) playButton.addEventListener('click', openVideoModal);
  if (modalClose) modalClose.addEventListener('click', closeVideoModal);
  if (modalBackdrop) modalBackdrop.addEventListener('click', closeVideoModal);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && videoModal && videoModal.style.display === 'flex') closeVideoModal();
  });

  // ========================================
  // TESTIMONIALS - REVEAL ANIMATION
  // ========================================

  const reviewsSection = document.querySelector('.reviews-section');

  if (reviewsSection && hasGSAP) {
    const reviewsHeading = reviewsSection.querySelector('.reviews-heading');
    const reviewCards = reviewsSection.querySelectorAll('.review-card');

    const reviewsObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          gsap.to(reviewsHeading, { opacity: 1, y: 0, duration: 0.8, ease: 'power3.out' });
          reviewCards.forEach((card, index) => {
            gsap.to(card.querySelectorAll('.star.filled'), {
              scale: 1, opacity: 1, duration: 0.3, stagger: 0.1,
              delay: 0.5 + (index * 0.1), ease: 'back.out(1.7)'
            });
          });
          reviewsObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2 });

    reviewsObserver.observe(reviewsSection);

    reviewCards.forEach(card => {
      gsap.set(card.querySelectorAll('.star.filled'), { scale: 0, opacity: 0 });
    });
  }

  // ========================================
  // TESTIMONIALS - DRAGGABLE SCROLL
  // ========================================

  const reviewsContainer = document.getElementById('reviewsContainer');
  const reviewsTrack = document.getElementById('reviewsTrack');
  const scrollProgress = document.getElementById('scrollProgress');

  if (reviewsContainer && reviewsTrack && window.innerWidth > 768) {

    let isDragging = false;
    let startX = 0;
    let scrollLeft = 0;
    let currentScroll = 0;
    let targetScroll = 0;
    let velocity = 0;

    const reviewCards = Array.from(reviewsTrack.querySelectorAll('.review-card'));
    const totalCards = reviewCards.length;

    if (totalCards > 0) {
      const containerWidth = reviewsContainer.getBoundingClientRect().width;
      const containerCenter = containerWidth / 2;
      const cardWidth = reviewCards[0].getBoundingClientRect().width;
      const gap = 32;
      const cardFullWidth = cardWidth + gap;
      let currentIndex = 0;
      let autoplayInterval;

      function getScrollPositionForCard(index) {
        return -((index * cardFullWidth) + (cardWidth / 2) - containerCenter);
      }

      function snapToCard(index) {
        const safeIndex = Math.max(0, Math.min(index, totalCards - 1));
        targetScroll = getScrollPositionForCard(safeIndex);
        currentIndex = safeIndex;
      }

      function findCenterCard() {
        let closestIndex = 0, closestDistance = Infinity;
        reviewCards.forEach((card, index) => {
          const dist = Math.abs((index * cardFullWidth) + (cardWidth / 2) + currentScroll - containerCenter);
          if (dist < closestDistance) { closestDistance = dist; closestIndex = index; }
        });
        return closestIndex;
      }

      function updateActiveCard() {
        const centerIndex = findCenterCard();
        reviewCards.forEach((card, index) => card.classList.toggle('active', index === centerIndex));
        if (scrollProgress) {
          scrollProgress.style.width = `${Math.max(0, Math.min(100, (centerIndex / (totalCards - 1)) * 100))}%`;
        }
      }

      function animateScroll() {
        velocity += (targetScroll - currentScroll) * 0.15;
        velocity *= 0.85;
        currentScroll += velocity;
        if (hasGSAP) {
          gsap.set(reviewsTrack, { x: currentScroll, force3D: true });
        } else {
          reviewsTrack.style.transform = `translateX(${currentScroll}px)`;
        }
        updateActiveCard();
        requestAnimationFrame(animateScroll);
      }

      reviewsContainer.addEventListener('mousedown', (e) => {
        isDragging = true;
        reviewsContainer.classList.add('dragging');
        startX = e.pageX;
        scrollLeft = currentScroll;
        velocity = 0;
        stopAutoplay();
      });

      document.addEventListener('mousemove', (e) => {
        if (!isDragging) return;
        e.preventDefault();
        targetScroll = scrollLeft + (e.pageX - startX) * 1.5;
      });

      document.addEventListener('mouseup', () => {
        if (isDragging) {
          isDragging = false;
          reviewsContainer.classList.remove('dragging');
          snapToCard(findCenterCard());
          startAutoplay();
        }
      });

      reviewsContainer.addEventListener('touchstart', (e) => {
        isDragging = true;
        startX = e.touches[0].pageX;
        scrollLeft = currentScroll;
        velocity = 0;
        stopAutoplay();
      });

      reviewsContainer.addEventListener('touchmove', (e) => {
        if (!isDragging) return;
        targetScroll = scrollLeft + (e.touches[0].pageX - startX) * 1.5;
      });

      reviewsContainer.addEventListener('touchend', () => {
        if (isDragging) { isDragging = false; snapToCard(findCenterCard()); startAutoplay(); }
      });

      function startAutoplay() {
        stopAutoplay();
        autoplayInterval = setInterval(() => {
          if (!isDragging) { currentIndex = (currentIndex + 1) % totalCards; snapToCard(currentIndex); }
        }, 5000);
      }

      function stopAutoplay() {
        clearInterval(autoplayInterval);
      }

      reviewsContainer.addEventListener('mouseenter', stopAutoplay);
      reviewsContainer.addEventListener('mouseleave', () => { if (!isDragging) startAutoplay(); });

      animateScroll();
      setTimeout(() => { snapToCard(0); startAutoplay(); }, 100);

      let resizeTimeout;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => location.reload(), 500);
      });
    }
  }

  // ========================================
  // BLOG SECTION - SCROLL REVEAL
  // ========================================

  const blogCards = document.querySelectorAll('.blog-card');

  if (blogCards.length > 0) {
    const blogObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setTimeout(() => { entry.target.classList.add('reveal'); }, entry.target.dataset.index * 150);
          blogObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -80px 0px' });

    blogCards.forEach(card => blogObserver.observe(card));
  }

  // ========================================
  // FAQ SECTION - SMOOTH ACCORDION
  // ========================================

  const faqQuestions = document.querySelectorAll('.faq-question');

  if (faqQuestions.length > 0) {
    faqQuestions.forEach(question => {
      question.addEventListener('click', function() {
        const faqItem = this.closest('.faq-item');
        const faqAnswer = faqItem.querySelector('.faq-answer');
        const faqAnswerContent = faqItem.querySelector('.faq-answer-content');
        const isActive = faqItem.classList.contains('active');

        document.querySelectorAll('.faq-item').forEach(item => {
          if (item !== faqItem && item.classList.contains('active')) {
            item.classList.remove('active');
            item.querySelector('.faq-answer').style.maxHeight = '0px';
            item.querySelector('.faq-question').setAttribute('aria-expanded', 'false');
          }
        });

        if (isActive) {
          faqItem.classList.remove('active');
          faqAnswer.style.maxHeight = '0px';
          question.setAttribute('aria-expanded', 'false');
        } else {
          faqItem.classList.add('active');
          faqAnswer.style.maxHeight = faqAnswerContent.scrollHeight + 'px';
          question.setAttribute('aria-expanded', 'true');
          if (window.innerWidth < 768) {
            setTimeout(() => faqItem.scrollIntoView({ behavior: 'smooth', block: 'nearest' }), 300);
          }
        }
      });
    });
  }

// ─── END OF DOMContentLoaded ───────────────────────────────────────────────
});
(function () {
  'use strict';

  function initOccasionSwipers() {
    document.querySelectorAll('[data-occasion-swiper]').forEach(function (el) {
      if (el.swiper) return; // already initialized — skip

      var wrapper = el.closest('.occasion-slider-wrapper');
      var prevBtn = wrapper ? wrapper.querySelector('[data-occasion-prev]') : null;
      var nextBtn = wrapper ? wrapper.querySelector('[data-occasion-next]') : null;

            var realCount = parseInt(el.dataset.occasionCount, 10) || 4;

      new Swiper(el, {
        effect: 'coverflow',
        centeredSlides: true,
        speed: 700,
        loop: true,
        slidesPerView: 3,
        initialSlide: realCount,
        grabCursor: true,
        watchSlidesProgress: true,
        watchOverflow: false,
        coverflowEffect: {
          rotate: 9,
          stretch: 0,
          depth: 200,
          modifier: 1,
          slideShadows: false
        },
        autoplay: {
          delay: 3200,
          disableOnInteraction: false,
          pauseOnMouseEnter: true
        },
        navigation: {
          nextEl: nextBtn,
          prevEl: prevBtn
        },
        breakpoints: {
          320: { slidesPerView: 2 },
          768: { slidesPerView: 2 },
          1024: { slidesPerView: 3 }
        },
        keyboard: {
          enabled: true,
          onlyInViewport: true
        },
        a11y: {
          enabled: true
        }
      });
    });
  }

  function boot() {
    if (typeof Swiper === 'undefined') {
      setTimeout(boot, 50); // Swiper CDN script may still be loading
      return;
    }
    initOccasionSwipers();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target.querySelector('[data-occasion-swiper]')) {
        setTimeout(boot, 80);
      }
    });
  }
})();

// ============================================================
// SEARCH RESULTS CONTROL — Noorvyaa
// Hides predictive results until user types.
// Isolated, loop-safe, production ready.
// ============================================================

(function () {
  'use strict';

  var initialized = false;
  var currentInput = null;
  var innerObserver = null;

  // ── Selectors confirmed from your DevTools ──
  var MODAL_SEL   = 'dialog.search-modal__content';
  var RESULTS_SEL = '.predictive-search-results__inner';
  var INPUT_SEL   = 'input#cmdk-input';

  // ── Hide / show results based on query ──────
  function enforce() {
    var modal = document.querySelector(MODAL_SEL);
    if (!modal) return;

    var results = modal.querySelector(RESULTS_SEL);
    var input   = modal.querySelector(INPUT_SEL);
    if (!results) return;

    var hasQuery = input && input.value.trim().length > 0;
    results.style.setProperty('display', hasQuery ? '' : 'none', 'important');
  }

  // ── Attach input listener once per modal open ──
  function attachInputListener() {
    var modal = document.querySelector(MODAL_SEL);
    if (!modal) return;

    var input = modal.querySelector(INPUT_SEL);
    if (!input || input === currentInput) return;

    currentInput = input;
    input.addEventListener('input', enforce);
    enforce(); // run once on open
  }

  // ── Watch ONLY inside the modal for results being injected ──
  function observeModal() {
    var modal = document.querySelector(MODAL_SEL);
    if (!modal) return;

    if (innerObserver) innerObserver.disconnect();

    innerObserver = new MutationObserver(function () {
      enforce();
      attachInputListener();
    });

    innerObserver.observe(modal, { childList: true, subtree: true });
    attachInputListener();
  }

  // ── Watch ONLY the dialog's open attribute — not entire body ──
  function watchDialogOpen() {
    var modal = document.querySelector(MODAL_SEL);
    if (!modal) {
      // Modal not in DOM yet — wait for it once
      var bodyWatcher = new MutationObserver(function (mutations, obs) {
        var m = document.querySelector(MODAL_SEL);
        if (m) {
          obs.disconnect(); // stop immediately — don't keep watching body
          watchDialogOpen();
        }
      });
      bodyWatcher.observe(document.body, { childList: true });
      return;
    }

    // Watch only the open attribute on the dialog element itself
    var dialogWatcher = new MutationObserver(function () {
      var isOpen = modal.hasAttribute('open');
      if (isOpen) {
        observeModal();
      } else {
        if (innerObserver) innerObserver.disconnect();
        currentInput = null;
      }
    });

    dialogWatcher.observe(modal, { attributes: true, attributeFilter: ['open'] });

    // If already open on init
    if (modal.hasAttribute('open')) observeModal();
  }

  // ── Init ────────────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchDialogOpen);
  } else {
    watchDialogOpen();
  }

})();

(function () {
  'use strict';

  var existing = document.getElementById('nv-search-luxury-ui');
  if (existing) existing.remove();

  var style = document.createElement('style');
  style.id = 'nv-search-luxury-ui';
  style.textContent = `

    /* ── RESET REBEL PINK COMPLETELY ── */
    dialog.search-modal__content.dialog-modal {
  --color-foreground: 26, 26, 26 !important;
  --color-background: 250, 250, 248 !important;
  --color-border: 232, 228, 222 !important;
  --color-button: 26, 26, 26 !important;
  --color-button-text: 250, 250, 248 !important;
  --product-card-corners-radius: 3px !important;
  accent-color: #1a1a1a !important;
}

dialog.search-modal__content.dialog-modal .predictive-search.color-scheme-3,
dialog.search-modal__content.dialog-modal .predictive-search-component {
  --color-foreground: 26, 26, 26 !important;
  --color-background: 250, 250, 248 !important;
  --color-border: 232, 228, 222 !important;
  --color-button: 26, 26, 26 !important;
  --color-button-text: 250, 250, 248 !important;
}

    /* ── DIALOG — centered, fixed, premium ── */
    dialog.search-modal__content.dialog-modal {
      position: fixed !important;
      top: 50% !important;
      left: 50% !important;
      transform: translate(-50%, -50%) !important;
      width: min(700px, 94vw) !important;
      max-height: 84vh !important;
      border-radius: 6px !important;
      border: 1px solid #e4dfd8 !important;
      box-shadow:
        0 2px 4px rgba(0,0,0,0.04),
        0 8px 24px rgba(0,0,0,0.08),
        0 32px 64px rgba(0,0,0,0.10) !important;
      margin: 0 !important;
      padding: 0 !important;
      overflow: hidden !important;
      background: #FAFAF8 !important;
    }

    dialog.search-modal__content.dialog-modal::backdrop {
      background: rgba(8, 6, 4, 0.55) !important;
      backdrop-filter: blur(5px) !important;
      -webkit-backdrop-filter: blur(5px) !important;
    }

    /* ── FORM HEADER — the input row ── */
    .predictive-search-form__header,
    .predictive-search-form_header {
      background: #FAFAF8 !important;
      border-bottom: 1px solid #e8e4de !important;
      padding: 0 24px !important;
      height: 68px !important;
      display: flex !important;
      align-items: center !important;
      gap: 16px !important;
      flex-shrink: 0 !important;
    }

    /* ── SEARCH ICON — properly sized, not cramped ── */
    .predictive-search-form__header .svg-wrapper,
    .predictive-search-form_header .svg-wrapper,
    .svg-wrapper.predictive-search-icon {
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      flex-shrink: 0 !important;
      width: 20px !important;
      height: 20px !important;
      opacity: 0.45 !important;
      color: #1a1a1a !important;
    }

    .predictive-search-form__header .svg-wrapper svg,
    .predictive-search-form_header .svg-wrapper svg,
    .svg-wrapper.predictive-search-icon svg {
      width: 18px !important;
      height: 18px !important;
      stroke: #1a1a1a !important;
      fill: none !important;
      display: block !important;
    }

    /* ── INPUT ── */
    input#cmdk-input,
    .predictive-search-form__header input[type="search"],
    .predictive-search-form_header input[type="search"],
    .predictive-search-form__header input {
      font-family: Georgia, 'Times New Roman', serif !important;
      font-size: 19px !important;
      font-weight: 400 !important;
      letter-spacing: 0.015em !important;
      color: #1a1a1a !important;
      background: transparent !important;
      border: none !important;
      outline: none !important;
      box-shadow: none !important;
      -webkit-appearance: none !important;
      appearance: none !important;
      width: 100% !important;
      flex: 1 !important;
      min-width: 0 !important;
      padding: 0 !important;
      margin: 0 !important;
      caret-color: #b76e79 !important;
      line-height: 1.4 !important;
    }

    input#cmdk-input::placeholder,
    .predictive-search-form__header input::placeholder {
      color: #bbb6ae !important;
      font-style: italic !important;
      font-size: 19px !important;
      font-family: Georgia, 'Times New Roman', serif !important;
    }

    /* Kill browser default search input decorations */
    input#cmdk-input::-webkit-search-decoration,
    input#cmdk-input::-webkit-search-cancel-button,
    input#cmdk-input::-webkit-search-results-button,
    input#cmdk-input::-webkit-search-results-decoration {
      display: none !important;
      -webkit-appearance: none !important;
    }

    /* ── CLEAR BUTTON — right of input ── */
    .predictive-search__reset-button,
    button[ref="resetButton"],
    .predictive-search-form__header button[aria-label*="lear"],
    .predictive-search-form_header button[aria-label*="lear"] {
      background: transparent !important;
      border: none !important;
      padding: 0 !important;
      margin: 0 !important;
      color: #9e9890 !important;
      font-family: 'Helvetica Neue', Helvetica, sans-serif !important;
      font-size: 10px !important;
      font-weight: 500 !important;
      letter-spacing: 0.16em !important;
      text-transform: uppercase !important;
      cursor: pointer !important;
      flex-shrink: 0 !important;
      white-space: nowrap !important;
      transition: color 0.2s ease !important;
      line-height: 1 !important;
    }

    .predictive-search__reset-button:hover,
    button[ref="resetButton"]:hover {
      color: #1a1a1a !important;
    }

    /* ── CLOSE BUTTON ── */
    .predictive-search .close-modal-button,
    dialog.search-modal__content button[aria-label="Close dialog"],
    .search-modal .close-modal-button {
      background: transparent !important;
      border: 1px solid #e0dbd4 !important;
      border-radius: 50% !important;
      width: 32px !important;
      height: 32px !important;
      min-width: 32px !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      cursor: pointer !important;
      color: #5a5550 !important;
      flex-shrink: 0 !important;
      padding: 0 !important;
      /* No layout-shifting transitions — only color */
      transition: background 0.2s ease, border-color 0.2s ease, color 0.2s ease !important;
    }

    .predictive-search .close-modal-button:hover,
    dialog.search-modal__content button[aria-label="Close dialog"]:hover {
      background: #f2ece6 !important;
      border-color: #c8c0b6 !important;
      color: #1a1a1a !important;
    }

    .predictive-search .close-modal-button svg,
    dialog.search-modal__content button[aria-label="Close dialog"] svg {
      width: 14px !important;
      height: 14px !important;
      display: block !important;
    }

    /* ── RESULTS SCROLL CONTAINER ── */
    .predictive-search-results__inner {
      background: #FAFAF8 !important;
      overflow-y: auto !important;
      overflow-x: hidden !important;
      max-height: calc(84vh - 68px - 68px) !important;
      padding: 4px 0 8px !important;
      scroll-behavior: smooth !important;
    }

    /* ── SECTION HEADINGS ("Products", "Collections") ── */
    .predictive-search-results__title,
    .predictive-search__heading,
    .predictive-search-results h2,
    .predictive-search-results h3,
    .predictive-search-results__inner h2,
    .predictive-search-results__inner h3 {
      font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif !important;
      font-size: 9px !important;
      font-weight: 600 !important;
      letter-spacing: 0.22em !important;
      text-transform: uppercase !important;
      color: #b5b0a8 !important;
      padding: 20px 28px 8px !important;
      margin: 0 !important;
      border: none !important;
      background: transparent !important;
      line-height: 1 !important;
    }

    /* ── SUGGESTION ROW (autocomplete text items like "ring") ── */
    .predictive-search__item,
    .predictive-search-results__item,
    .predictive-search__list-item,
    .predictive-search-results ul li a,
    .predictive-search-results ul li {
      background: transparent !important;
      border: none !important;
      padding: 10px 28px !important;
      margin: 0 !important;
      color: #2a2520 !important;
      font-family: 'Helvetica Neue', Helvetica, sans-serif !important;
      font-size: 14px !important;
      letter-spacing: 0.01em !important;
      display: flex !important;
      align-items: center !important;
      gap: 10px !important;
      cursor: pointer !important;
      /* KEY: only background changes, no padding/margin shifts */
      transition: background 0.15s ease !important;
      will-change: background !important;
    }

    .predictive-search__item:hover,
    .predictive-search-results__item:hover,
    .predictive-search__list-item:hover,
    .predictive-search-results ul li a:hover {
      background: #f0ece5 !important;
      color: #1a1a1a !important;
      padding: 10px 28px !important; /* LOCKED — prevents jump */
    }

    /* Kill pink matched text highlight */
    .predictive-search mark,
    .predictive-search-results mark,
    .predictive-search__item mark {
      background: transparent !important;
      color: #b76e79 !important;
      font-weight: 600 !important;
    }

    /* ── PRODUCT CARD GRID ── */
    .predictive-search-results .predictive-search__results-col,
    .predictive-search-results__inner .predictive-search__results-col {
      padding: 4px 20px 8px !important;
    }

    .predictive-search-results ul.list-unstyled {
      display: grid !important;
      grid-template-columns: repeat(auto-fill, minmax(160px, 1fr)) !important;
      gap: 12px !important;
      padding: 4px 8px !important;
      margin: 0 !important;
      list-style: none !important;
    }

    /* ── INDIVIDUAL PRODUCT CARD ── */
    .predictive-search-results .card-wrapper,
    .predictive-search-results .card {
      background: #fff !important;
      border: 1px solid #ede9e2 !important;
      border-radius: 4px !important;
      overflow: hidden !important;
      /* Smooth lift, no layout shift */
      transition: box-shadow 0.22s ease, transform 0.22s ease !important;
      will-change: transform, box-shadow !important;
      transform: translateZ(0) !important; /* force GPU layer to prevent repaint jump */
    }

    .predictive-search-results .card-wrapper:hover,
    .predictive-search-results .card:hover {
      box-shadow: 0 4px 20px rgba(0,0,0,0.09) !important;
      transform: translateY(-2px) translateZ(0) !important;
      border-color: #d8d2ca !important;
    }

    /* Product image */
    .predictive-search-results .card__media,
    .predictive-search-results .media {
      background: #f7f5f2 !important;
      aspect-ratio: 1 / 1 !important;
      overflow: hidden !important;
    }

    .predictive-search-results .card__media img,
    .predictive-search-results .media img {
      width: 100% !important;
      height: 100% !important;
      object-fit: cover !important;
      transition: transform 0.35s ease !important;
      will-change: transform !important;
    }

    .predictive-search-results .card-wrapper:hover img,
    .predictive-search-results .card:hover img {
      transform: scale(1.04) !important;
    }

    /* Product name */
    .predictive-search-results .card__heading,
    .predictive-search-results .card__heading a,
    .predictive-search-results .full-unstyled-link {
      font-family: Georgia, 'Times New Roman', serif !important;
      font-size: 12px !important;
      font-weight: 400 !important;
      color: #1a1a1a !important;
      letter-spacing: 0.01em !important;
      line-height: 1.4 !important;
      text-decoration: none !important;
    }

    /* Product price */
    .predictive-search-results .price,
    .predictive-search-results .price__regular,
    .predictive-search-results .price-item,
    .predictive-search-results .price-item--regular {
      font-family: 'Helvetica Neue', Helvetica, sans-serif !important;
      font-size: 11px !important;
      font-weight: 400 !important;
      color: #6b6560 !important;
      letter-spacing: 0.04em !important;
    }

    /* Sale / compare price */
    .predictive-search-results .price-item--sale {
      color: #b76e79 !important;
    }

    .predictive-search-results .price-item--regular.price-item--last:not(.price-item--sale) {
      text-decoration: line-through !important;
      color: #b5b0a8 !important;
    }

    /* Card info padding */
    .predictive-search-results .card__information {
      padding: 10px 12px 12px !important;
      background: #fff !important;
    }

    /* ── COLLECTIONS in results ── */
    .predictive-search-results .predictive-search__list-item.predictive-search__item--collection,
    .predictive-search-results [class*="collection"] .predictive-search__item {
      padding: 8px 20px !important;
      transition: background 0.15s ease !important;
      will-change: background !important;
    }

    .predictive-search-results .predictive-search__list-item.predictive-search__item--collection:hover {
      background: #f0ece5 !important;
      padding: 8px 20px !important; /* LOCKED */
    }

    .dialog-modal .predictive-search-form__header{
      padding-left: 2.5rem !important;  
    }

    /* ── FOOTER — VIEW ALL button ── */
    .predictive-search-form__footer,
    .predictive-search-form_footer,
    .predictive-search-results__footer {
      background: #FAFAF8 !important;
      border-top: 1px solid #e8e4de !important;
      padding: 16px 28px !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      flex-shrink: 0 !important;
    }

    .predictive-search-search-button,
    .predictive-search-form__footer .button,
    .predictive-search-form_footer .button,
    button.button.button-primary.predictive-search-search-button {
      background: #1a1a1a !important;
      color: #FAFAF8 !important;
      border: 1px solid #1a1a1a !important;
      border-radius: 2px !important;
      font-family: 'Helvetica Neue', Helvetica, sans-serif !important;
      font-size: 10px !important;
      font-weight: 600 !important;
      letter-spacing: 0.18em !important;
      text-transform: uppercase !important;
      padding: 13px 36px !important;
      cursor: pointer !important;
      /* No size/padding change on hover — only color */
      transition: background 0.22s ease, border-color 0.22s ease, color 0.22s ease !important;
      will-change: background !important;
      min-width: 160px !important;
      text-align: center !important;
    }

    .predictive-search-search-button:hover,
    .predictive-search-form__footer .button:hover,
    button.button.button-primary.predictive-search-search-button:hover {
      background: #b76e79 !important;
      border-color: #b76e79 !important;
      color: #fff !important;
      /* LOCKED — no padding/size change */
      padding: 13px 36px !important;
    }

    /* ── SCROLLBAR — whisper thin ── */
    .predictive-search-results__inner::-webkit-scrollbar {
      width: 3px !important;
    }
    .predictive-search-results__inner::-webkit-scrollbar-track {
      background: transparent !important;
    }
    .predictive-search-results__inner::-webkit-scrollbar-thumb {
      background: #d4cfc8 !important;
      border-radius: 2px !important;
    }
    .predictive-search-results__inner::-webkit-scrollbar-thumb:hover {
      background: #b5b0a8 !important;
    }

  `;

  if (!document.getElementById('nv-search-luxury-ui')) {
    document.head.appendChild(style);
  }

})();

(function() {
  'use strict';

  if (document.querySelector('[data-testid="product-information-details"]')) return;

  function formatINR(n) {
    return '₹' + Math.round(n).toLocaleString('en-IN');
  }

  function updateAllCards(prices) {
    document.querySelectorAll('[data-nv-card-price]').forEach(function(card) {
      var weight  = parseFloat(card.dataset.metalWeight);
      var diamond = parseFloat(card.dataset.diamondCost)  || 0;
      var making  = parseFloat(card.dataset.makingCharges) || 0;
      var type    = card.dataset.metalType;

      if (!weight || !type) return;

      var total = Math.round((weight * prices.silver_925 + diamond + making) * 1.03);
      var display = card.querySelector('[data-nv-price-display]');
      if (display) {
        display.textContent = formatINR(total);
        display.style.display = 'block';
      }
    });
  }

  function tryUpdate() {
    if (window.__nvMetalPrices) {
      updateAllCards(window.__nvMetalPrices);
    }
  }

  // Try immediately
  tryUpdate();

  // Try after DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryUpdate);
  }

  // Try after full load
  window.addEventListener('load', tryUpdate);

  // Listen for the event
  window.addEventListener('nv:metalPricesReady', function(e) {
    updateAllCards(e.detail);
  });

  // Final safety net — retry after 2 seconds
  setTimeout(tryUpdate, 2000);

})();

(function () {
  'use strict';

  // ── NV Custom Price Sort ──
  // Intercepts price-ascending / price-descending sort options
  // and reorders cards using our dynamically calculated prices.
  // All other sort options (alphabetical, date, etc.) pass through
  // to Shopify's native sort unchanged.

  var NV_PRICE_SORT = {

    currentSort: null,

    init: function () {
      var self = this;

      // Wait for DOM ready
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
          self.attach();
        });
      } else {
        self.attach();
      }
    },

    attach: function () {
      var self = this;

      // Find both price sort labels (ascending + descending)
      var priceAscLabel = document.querySelector(
        'label[for*="price-ascending"]'
      );
      var priceDescLabel = document.querySelector(
        'label[for*="price-descending"]'
      );

      if (!priceAscLabel && !priceDescLabel) return;

      // Check if URL already has price sort active on page load
      var urlSort = new URLSearchParams(window.location.search).get('sort_by');
      if (urlSort === 'price-ascending' || urlSort === 'price-descending') {
        self.currentSort = urlSort;
        // Wait for prices to be calculated then sort
        if (window.__nvMetalPrices) {
          setTimeout(function () { self.applySort(urlSort); }, 600);
        } else {
          window.addEventListener('nv:metalPricesReady', function () {
            setTimeout(function () { self.applySort(urlSort); }, 600);
          });
        }
      }

      // Intercept price-ascending click
      if (priceAscLabel) {
        priceAscLabel.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopImmediatePropagation();
          self.currentSort = 'price-ascending';
          self.markActive(priceAscLabel);
          self.updateURL('price-ascending');
          if (window.__nvMetalPrices) {
            self.applySort('price-ascending');
          } else {
            window.addEventListener('nv:metalPricesReady', function () {
              self.applySort('price-ascending');
            });
          }
        }, true);
      }

      // Intercept price-descending click
      if (priceDescLabel) {
        priceDescLabel.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopImmediatePropagation();
          self.currentSort = 'price-descending';
          self.markActive(priceDescLabel);
          self.updateURL('price-descending');
          if (window.__nvMetalPrices) {
            self.applySort('price-descending');
          } else {
            window.addEventListener('nv:metalPricesReady', function () {
              self.applySort('price-descending');
            });
          }
        }, true);
      }

      // When any OTHER sort option is clicked, reset our custom sort
      document.querySelectorAll(
        'label[for*="sort-option"]:not([for*="price-ascending"]):not([for*="price-descending"])'
      ).forEach(function (label) {
        label.addEventListener('click', function () {
          self.currentSort = null;
          self.resetGrid();
        });
      });
    },

    // Get calculated price for a card
    getCardPrice: function (card) {
      var display = card.querySelector('[data-nv-price-display]');
      if (!display) return 0;
      var text = display.textContent.replace(/[^0-9]/g, '');
      return parseInt(text, 10) || 0;
    },

    // Sort the product grid
    applySort: function (direction) {
      var grid = document.querySelector(
        '.product-grid, [data-testid="resource-list-grid"], .resource-list--grid'
      );
      if (!grid) return;

      // Get all direct product card wrappers
      var items = Array.from(
        grid.querySelectorAll(
          '.resource-list__item, product-card-link, .product-card'
        )
      );

      // Deduplicate — get only direct children
      var directItems = Array.from(grid.children).filter(function (child) {
        return child.querySelector('[data-nv-card-price]') ||
               child.querySelector('[data-nv-price-display]') ||
               child.matches('product-card-link') ||
               child.matches('.resource-list__item');
      });

      if (!directItems.length) return;

      // Assign price to each item
      directItems.forEach(function (item) {
        var display = item.querySelector('[data-nv-price-display]');
        var text = display ? display.textContent.replace(/[^0-9]/g, '') : '0';
        item._nvPrice = parseInt(text, 10) || 0;
      });

      // Sort
      directItems.sort(function (a, b) {
        if (direction === 'price-ascending') {
          return a._nvPrice - b._nvPrice;
        } else {
          return b._nvPrice - a._nvPrice;
        }
      });

      // Re-append in sorted order
      directItems.forEach(function (item) {
        grid.appendChild(item);
      });
    },

    // Reset grid to original DOM order (Shopify's current sort)
    resetGrid: function () {
      // Do nothing — let Shopify handle it via page reload
    },

    // Update URL without page reload for display only
    updateURL: function (sortValue) {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortValue);
      window.history.pushState({}, '', url.toString());

      // Update the status text in the sort button
      var statusEl = document.querySelector('.facets__status');
      if (statusEl) {
        statusEl.textContent = sortValue === 'price-ascending'
          ? 'Price, low to high'
          : 'Price, high to low';
      }
    },

    // Mark the clicked label as active visually
    markActive: function (activeLabel) {
      // Remove active from all sort options
      document.querySelectorAll('.sorting-filter__option').forEach(function (opt) {
        opt.setAttribute('aria-selected', 'false');
        opt.setAttribute('tabindex', '-1');
        var input = opt.querySelector('input');
        if (input) input.checked = false;
      });

      // Set active on clicked
      var option = activeLabel.querySelector('.sorting-filter__option');
      if (option) {
        option.setAttribute('aria-selected', 'true');
        option.setAttribute('tabindex', '0');
        var input = option.querySelector('input');
        if (input) input.checked = true;
      }
    }

  };

  // Only run on collection pages
  if (
    window.location.pathname.indexOf('/collections/') !== -1 ||
    document.querySelector('[data-testid="resource-list-grid"]')
  ) {
    // Wait for prices to be ready before initialising
    if (window.__nvMetalPrices) {
      NV_PRICE_SORT.init();
    } else {
      window.addEventListener('nv:metalPricesReady', function () {
        NV_PRICE_SORT.init();
      });
      // Also init immediately in case event already fired
      NV_PRICE_SORT.init();
    }
  }

})();

